
import React, { Component } from "react";
import {
    DKLabel, DKButton, DKIcon

} from "deskera-ui-library";
import ic_close from '../../assets/icons/ic_close.png';
import ic_info_warning from "../../assets/icons/ic_info_warning.svg";

export default class MessageInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            toggle: true
        }
    }
    componentDidUpdate(prevProps, prevState) {

    }
    render() {
        return (
          <>
            {this.state.toggle && (
              <div className={`row ${this.props.bannerClass}`}>
                <div className=" bg-deskera-secondary p-r border-radius-m border-m parent-width d-flex justify-content-between ">
                  <span className="d-flex" style={{ alignItems: "center" }}>
                    <DKIcon className="mr-s" src={ic_info_warning} />
                    {this.props.message &&
                      this.props.message.length > 0 &&
                      this.props.message.map((object) => {
                        return (
                          <>
                            <div
                              className=""
                              style={{ margin: "0px", textAlign: "initial" }}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: object.message,
                                }}
                              ></span>
                              {object.isAction && (
                                <a
                                  onClick={() => object.action(object)}
                                  class="cursor-hand text-app-color"
                                >
                                  &nbsp;
                                  <u>{object.actionText}</u>
                                  &nbsp;
                                </a>
                              )}
                              {object.addtionalText && (
                                <>{object.addtionalText}</>
                              )}
                            </div>
                          </>
                        );
                      })}
                  </span>

                  {this.props.isClosable && (
                    <span className="d-flex ml-s" style={{alignItems:"center"}}>
                      <DKIcon
                        className="cursor-hand ic-s"
                        src={ic_close}
                        onClick={() => this.setState({ toggle: false })}
                      />
                    </span>
                  )}
                </div>
              </div>
            )}
          </>
        );
    }

}